<app-modal>
  <app-loading *ngIf="isLoading"></app-loading>
  <ng-container *ngIf="!isLoading">
    <app-modal-header
      [title]="T.common.add_item | translate: { item: templateRisk }"
      [showDelete]="false"
      (closed)="closeModal()">
    </app-modal-header>

    <app-modal-body>
      <div class="additional-info">{{ T.defaultLocalizations.template_risk_add_modal_info | translate }}</div>
      <!-- <app-suggested-risks-list
        [isWithinAddRiskModal]="true"
        (prefillFormEvent)="handlePrefillForm($event)">
      </app-suggested-risks-list> -->

      <section class="row col-row-space custom-gutters section-padding" [formGroup]="form">
        <div class="selection col-12 mb-2">
          <app-text-field
            [showOutlined]="true"
            [removeBorders]="true"
            [displayError]="triggerErrors"
            [formGroup]="form"
            formControlName="riskTitle"
            [useReactiveMessages]="true"
            [maxLength]="250"
            [disableMargin]="true"
            [required]="true"
            [placeholder]="(T.defaultLocalizations.title.one | translate) + '*'">
          </app-text-field>
        </div>

        <div class="col-12 col-lg-6 mb-2">
          <div class="selection">
            <app-filter-dropdown-new
              [useSearch]="false"
              [showOutlined]="true"
              [removeBorders]="true"
              [label]="(T.common.probability.one | translate) + '*'"
              [displayError]="triggerErrors"
              [disableRequiredText]="true"
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Risk_Likelihood"
              [currentlySelectedSettingValue]="likelihoodValue?.toString()"
              [excludeFilterValues]="excludeLikelihoodFilterValues"
              [singleSelect]="true"
              [appliedFilters]="filters"
              [typeahead]="true"
              [disableMargin]="true"
              [required]="true"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-2">
          <div class="selection">
            <app-filter-dropdown-new
              [useSearch]="false"
              [showOutlined]="true"
              [removeBorders]="true"
              [label]="(T.common.impact.one | translate) + '*'"
              [displayError]="triggerErrors"
              [disableRequiredText]="true"
              [required]="true"
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Risk_Impact"
              [currentlySelectedSettingValue]="impactValue?.toString()"
              [singleSelect]="true"
              [appliedFilters]="filters"
              [typeahead]="true"
              [disableMargin]="true"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div [ngTemplateOutlet]="riskRAGTemplate"></div>
        </div>
        <div class="description col-12 mb-2">
          <app-details-editable-field
            [useOutlinedInput]="true"
            [input]="form.controls.riskDescription.value ? form.controls.riskDescription.value : ''"
            [type]="editableFieldTypes.RichText"
            [canEdit]="true"
            (onUpdate)="updateRiskDescription($event)"
            (onInputChange)="updateRiskDescription($event)"
            [placeholder]="T.common.add_description | translate">
          </app-details-editable-field>
        </div>
<div class="container-with-bottom-element d-flex flex-column col-12 mb-2">
          <div class="selection">
            <app-filter-dropdown-new
              [filterByModuleObjectType]="false"
              [displayError]="triggerErrors"
              [filterType]="filterTypes.Owner"
              [required]="false"
              [singleSelect]="false"
              [appliedFilters]="filters"
              [disableMargin]="false"
              [typeahead]="true"
              [removeIcon]="true"
              [removeBorders]="true"
              [showOutlined]="true"
              [useSearch]="false"
              [label]="(T.defaultLocalizations.owner.many | translate)"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
          </div>
          <div class="bottom-element d-flex">
            <app-button-transparent
              size="small"
              icon="add"
              [text]="T.common.assign_me | translate"
              (clicked)="setAccountForCurrentOwner()">
            </app-button-transparent>
          </div>
        </div>
         <div class="selection col-12 mb-2">
          <app-filter-dropdown-new
            [useSearch]="false"
            [showOutlined]="true"
            [removeBorders]="true"
            [disableMargin]="true"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Event_Type"
            [appliedFilters]="filters"
            [typeahead]="true"
            [label]=""
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>
        <div class="selection col-12 mb-2">
          <app-filter-dropdown-new
            [useSearch]="false"
            [showOutlined]="true"
            [removeBorders]="true"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Risk_Impact_Type"
            [disableMargin]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [label]="T.common.impact_type.many | translate: {impact: localisedImpact}"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>
        <div class="selection col-12 mb-2">
          <app-filter-dropdown-new
            [showOutlined]="true"
            [removeBorders]="true"
            [useSearch]="false"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Risk_Strategy"
            [singleSelect]="true"
            [disableMargin]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [label]="T.common.strategy.one | translate"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>
        <div class="selection col-12 mb-2">
          <app-filter-dropdown-new
            [showOutlined]="true"
            [removeBorders]="true"
            [useSearch]="false"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.User_Group"
            [singleSelect]="false"
            [disableMargin]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>

        <div class="container-with-bottom-element d-flex flex-column col-12 mb-2">
          <div class="selection">
            <app-filter-dropdown-new
              [useSearch]="false"
              [showOutlined]="true"
              [removeBorders]="true"
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Department"
              [disableMargin]="true"
              [appliedFilters]="filters"
              [typeahead]="true"
              [removeIcon]="true"
              [label]="localisedDepartment"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
          </div>
          <div class="bottom-element d-flex mt-1" *ngIf="employee?.departmentId > 0">
            <app-button-transparent
              size="small"
              icon="add"
              [text]="T.common.assign_my_localisedDepartment | translate: { localisedDepartment: localisedDepartment }"
              (clicked)="setMyDepartment()"
            ></app-button-transparent>
          </div>
        </div>

        <!-- <div class="col-12 mb-2">
          <app-filter-dropdown-new
            [useSearch]="false"
            [showOutlined]="true"
            [removeBorders]="true"
            [disableMargin]="true"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Identified_By"
            [singleSelect]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [label]="T.defaultLocalizations.identified_by.one | translate"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div> -->

        <div class="d-flex align-items-center col-12 mt-3 mb-0">
          <span class="risk-index me-3">
            {{ T.defaultLocalizations.tag.many | translate }}
          </span>
        </div>
        <app-add-modal-tag-groups
          class="col-12 mt-0"
          [showTitle]="false"
          [showOutlined]="true"
          [removeBorders]="true"
          [useSearch]="false"
          [removeIcon]="true"
          [disableMargin]="true"
          [layoutClasses]="'col-12 col-lg-6 mb-2'"
          [filters]="filters"
          [tagGroupObjectType]="objectTypes.Risk"
          (onFiltersUpdated)="handleFilterChange($event)">
        </app-add-modal-tag-groups>
      </section>
    </app-modal-body>

    <app-modal-footer>
      <app-button-rectangle
        class="button d-none d-md-block"
        [fitToContainer]="true"
        [size]="ButtonSizes.Large"
        [text]="T.common.cancel | translate"
        buttonTheme="white"
        (clicked)="confirmClose()">
      </app-button-rectangle>
      <app-button-rectangle
        [size]="ButtonSizes.Large"
        class="modal-confirm"
        [buttonTheme]="ButtonThemes.Primary"
        [text]="T.common.save | translate"
        [disabled]="!validateState()"
        [loading]="isLoading"
        (clicked)="onSave()">
      </app-button-rectangle>
    </app-modal-footer>
  </ng-container>
</app-modal>

<ng-template #riskRAGTemplate>
    <div class="risk-rag d-flex" [style.border-color]="ragColour" [style.background-color]="ragBackgroundColour">
      <div class="details-icon">
        <app-details-icon [size]="24" type="Risk" [backgroundFill]="ragColour"></app-details-icon>
      </div>
      <div>
        <span class="ms-2">{{ ragDescription }}</span>
      </div>
    </div>
  </ng-template>
